import { Description } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const AdditionalServicesPageLoad = createAction(
  '[GA Additional Services] Page Load'
);

export const AdditionalServicesContinueClick = createAction(
  '[GA Additional Services] Continue Click'
);

export const AdditionalServicesProtectionSelect = createAction(
  '[GA Additional Services] Protection Select'
);

export const AdditionalServicesExtraSelect = createAction(
  '[GA Additional Services] Add Extra',
  props<{ payload: Description }>()
);

export const AdditionalServicesOldPolicy = createAction(
  '[GA Additional Services] Old Policy',
  props<{ payload: string }>()
);

export const AdditionalServicesToggleBenefits = createAction(
  '[GA Additional Services] Toggle Benefits Policy',
  props<{ payload: { isOpen: boolean } }>()
);

export const AdditionalServicesRejectNewPolicy = createAction(
  '[GA Additional Services] Reject New Policy'
);

export const AdditionalServicesPopUpClose = createAction(
  '[GA Additional Services] PopupClose',
  props<{ payload: { upsellPopupAction: string } }>()
);

export const AdditionalServicesPopUpShow = createAction(
  '[GA Additional Services] Popup Show'
);

export type AdditionalServicesActions =
  | typeof AdditionalServicesPageLoad
  | typeof AdditionalServicesContinueClick
  | typeof AdditionalServicesPopUpClose
  | typeof AdditionalServicesPopUpShow
  | typeof AdditionalServicesProtectionSelect
  | typeof AdditionalServicesExtraSelect
  | typeof AdditionalServicesOldPolicy
  | typeof AdditionalServicesToggleBenefits
  | typeof AdditionalServicesRejectNewPolicy;
